import { t } from 'i18next';

import { AssignManufacturerCell } from 'bom/elements';
import { SwitchCell } from 'core/elements';

export const getColumnDefs = (isAlternateVersionEnabled: boolean) => [
  {
    colId: 'name',
    headerName: t('headerExistingManufacturer'),
    field: 'name',
  },
  {
    colId: 'assignTo',
    headerName: t('headerAssignTo'),
    field: 'assignTo',
    cellRenderer: AssignManufacturerCell,
    cellRendererParams: { isAlternateVersionEnabled },
  },
  {
    colId: 'omit',
    headerName: t('headerOmit'),
    field: 'omit',
    minWidth: 100,
    width: 100,
    maxWidth: 100,
    cellRenderer: SwitchCell,
    cellRendererParams: {
      colId: 'omit',
    },
  },
];
